var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 16.3359C12.6406 16.3359 16.3281 12.6406 16.3281 8.16406C16.3281 3.6875 12.6328 0 8.16406 0C3.6875 0 0 3.6875 0 8.16406C0 12.6406 3.6875 16.3359 8.16406 16.3359ZM7.29688 12.0547C6.96875 12.0547 6.71094 11.9141 6.47656 11.625L4.60156 9.36719C4.44531 9.16406 4.375 8.97656 4.375 8.76562C4.375 8.32031 4.72656 7.96875 5.17188 7.96875C5.42969 7.96875 5.63281 8.07031 5.83594 8.32031L7.27344 10.1094L10.4062 5.10938C10.5938 4.80469 10.8359 4.65625 11.1094 4.65625C11.5469 4.65625 11.9375 4.96875 11.9375 5.41406C11.9375 5.60156 11.8516 5.80469 11.7266 5.99219L8.07812 11.6094C7.89062 11.8984 7.60938 12.0547 7.29688 12.0547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComplete);
export default __webpack_public_path__ + "static/media/step-complete.2ed5cd03.svg";
export { ForwardRef as ReactComponent };